import type { NextPage } from 'next';

import NotFound from 'app/components/NotFound';

const NotFoundPage: NextPage = () => {
  return <NotFound />;
};

export { getStaticProps } from 'app/getStaticProps';

export default NotFoundPage;
